import AuditLogs from '../../pages/audit-logs/index.vue'
import DatabaseFirestore from '../../pages/database/firestore.vue'
import DatabaseLanding from '../../pages/database/index.vue'
import DatabaseMongo from '../../pages/database/mongo.vue'
import DependencyGraph from '../../pages/dependency-graph/index.vue'
import IAMConfig from '../../pages/iam-config/index.vue'
import Landing from '../../pages/Landing.vue'
import PackageDetails from '../../pages/package-details/index.vue'
import PackageView from '../../pages/package-view/index.vue'
import PlatformReport from '../../pages/platform-report/index.vue'
import PlatformReportCreate from '../../pages/platform-report/create.vue'
import PlatformReportEdit from '../../pages/platform-report/edit.vue'
import QualityGateDetails from '../../pages/quality-gates/details.vue'
import QualityGates from '../../pages/quality-gates/index.vue'
import CompliancePRs from '../../pages/quality-gates-compliance-prs/index.vue'
import QualityGatesLeaderboard from '../../pages/quality-gates-leaderboard/index.vue'
import QualityGatesLeaderboardDetails from '../../pages/quality-gates-leaderboard/details.vue'
import RequestFilters from '../../pages/request-filter/index.vue'
import type { RouteRecordRaw } from 'vue-router'
import SidePanel from '../../components/layout/SidePanel.vue'
import TaskSentinel from '../../pages/task-sentinel/index.vue'
import TaskSentinelDetails from '../../pages/task-sentinel/details.vue'
import WorkersFilter from '../../pages/workers-filter/index.vue'
import WorkloadDetails from '../../pages/workload-details/index.vue'
import { requireAuth } from '../middleware/auth'

export const mainRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: SidePanel,
    beforeEnter: requireAuth,
    children: [
      { path: '', component: Landing },
      { path: '/request-filter', component: RequestFilters },
      { path: '/workers-filter', component: WorkersFilter },
      { path: '/iam-config', component: IAMConfig },
      { path: '/audit-logs', component: AuditLogs },
      { path: '/database', component: DatabaseLanding },
      { path: '/database/firestore', component: DatabaseFirestore },
      { path: '/database/mongo', component: DatabaseMongo },
      { path: '/dependency-graph', component: DependencyGraph },
      { path: '/packages', component: PackageView },
      { path: '/packages/:packageName', component: PackageDetails },
      { path: '/packages/:packageName/:version', component: PackageDetails },
      { path: '/workload/:gitRepo/:workload/:environment', component: WorkloadDetails },
      { path: '/quality-gates', component: QualityGates },
      { path: '/quality-gates/compliance', component: QualityGatesLeaderboard },
      { path: '/quality-gates/compliance/details', component: QualityGatesLeaderboardDetails },
      { path: '/quality-gates/compliance/prs', component: CompliancePRs },
      { path: '/quality-gates/:repo/:prNumber', component: QualityGateDetails },
      { path: '/platform-report', component: PlatformReport },
      { path: '/platform-report/create', component: PlatformReportCreate },
      { path: '/platform-report/edit/:id', component: PlatformReportEdit },
      { path: '/task-sentinel', component: TaskSentinel },
      { path: '/ts', component: TaskSentinel },
      { path: '/task-sentinel/:id', component: TaskSentinelDetails }
    ]
  }
]
